import React from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  DialogActions,
  TextField,
  Typography,
  Box,
} from '@mui/material';
import { useGlobalContext } from '../../context/GlobalStore';
import { styles } from '../Account/styles';
import Loading from '../Loading';

const AddApiKeyModal = (props) => {
  const {
    open,
    handleClose,
    handleAddApiKey,
    newApiKey,
    setNewApiKey,
    isLoading,
  } = props;
  const { state } = useGlobalContext();
  const inputItems = [
    { label: 'API Key Name', name: 'api_key_name', type: 'text' },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;

    setNewApiKey((prev) => ({
    ...prev,
    [name]: value,
    }));
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      onSubmit={handleAddApiKey}
      component="form"
    >
      {isLoading ? (
        <DialogContent sx={styles.loadingBox}>
          <Loading />
        </DialogContent>
      ) : (
        <>
          <DialogTitle id="alert-dialog-title">{'Add New API Key'}</DialogTitle>
          <DialogContent>
            <Typography variant="body2" color="GrayText">
              It may take up to 10 minutes before requests to a new key can be accepted.
            </Typography>
          </DialogContent>
          <DialogContent sx={styles.contentBox}>
            {inputItems.map((item) => {
              return (
                <Box
                  display="flex"
                  alignItems="center"
                  key={`input-${item.name}`}
                >
                  <Typography sx={styles.label} variant="body1">
                    {item.label}:
                  </Typography>
                  <TextField
                    name={item.name}
                    size="small"
                    sx={styles.input}
                    type={item.type}
                    onChange={handleChange}
                    required
                  />
                </Box>
              );
            })}
          </DialogContent>
          <DialogActions sx={{ padding: 3 }}>
            <Button onClick={handleClose} variant="outlined">
              Cancel
            </Button>
            <Button variant="contained" type="submit" autoFocus>
              Add
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default AddApiKeyModal;
